/* tslint:disable */
import {
  ProductCategoryType
} from '../index';

declare var Object: any;
export interface ProductCategoryInterface {
  "id"?: number;
  "name": string;
  "product_type_value"?: number;
  product_type?: ProductCategoryType;
}

export class ProductCategory implements ProductCategoryInterface {
  "id": number;
  "name": string;
  "product_type_value": number;
  product_type: ProductCategoryType;
  constructor(data?: ProductCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProductCategory`.
   */
  public static getModelName() {
    return "ProductCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProductCategory for dynamic purposes.
  **/
  public static factory(data: ProductCategoryInterface): ProductCategory{
    return new ProductCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProductCategory',
      plural: 'ProductCategories',
      path: 'ProductCategories',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "product_type_value": {
          name: 'product_type_value',
          type: 'number'
        },
      },
      relations: {
        product_type: {
          name: 'product_type',
          type: 'ProductCategoryType',
          model: 'ProductCategoryType',
          relationType: 'belongsTo',
                  keyFrom: 'product_type_value',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ProductCategory.ts